export default __webpack_public_path__ + "static/media/syringe.fd869ee2.png";